module.exports = __webpack_public_path__ + "Wing_feathers_Normal.9ba2e74.basis";